<template>
  <div>
    <v-list class="pa-0 done-by-users-list mt-1"
            v-if="$vuetify.breakpoint.name === 'xs'">

      <v-list-item v-for="doneByUser in doneByUsers"
                   :key="doneByUser.worker.id"
                   class="pt-2 pb-2"
                   style="min-height: unset">
        <v-list-item-content class="pa-0">
          <v-list-item-title>
            <div> {{ doneByUser.worker | user }}</div>
          </v-list-item-title>
          <v-list-item-subtitle>
            <div class="d-flex flex-row align-baseline">
              <div class="grow pr-2" style="">{{ $t('service.userWorkDate') }}</div>
              <date-picker v-model="doneByUser.workDate"
                           dense
                           clearable
                           class="mr-2"/>
            </div>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <div class="d-flex flex-row align-baseline">
              <div class="grow pr-2" style="">{{ $t('service.userWorkDuration') }}</div>
              <duration-select v-model="doneByUser.workDuration"
                               class="mr-2 mt-1 mb-1"
                               style="max-width: 8em;"
                               dense/>
            </div>
            <v-divider/>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="ma-0">
          <v-btn @click="removeUser(doneByUser.worker)"
                 icon
                 :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-list-item-action>

      </v-list-item>

      <v-list-item>
        <v-list-item-content class="pa-0">
          <user-select-field :show-select-dialog-button="true"
                             :show-add-dialog-button="true"
                             :dense="true"
                             @change="addUser"
                             v-model="userToAdd"
                             class="mb-1 mt-1"
                             :label="$t('actions.add')"
                             :rules="[() => doneByUsers.length > 0 || $t('validation.required'), ]"/>
        </v-list-item-content>
      </v-list-item>
    </v-list>


    <v-data-table
        v-if="$vuetify.breakpoint.name !== 'xs'"
        :headers="headers"
        class="elevation-1 done-by-users-table"
        hide-default-footer
        :items="doneByUsers"
        dense
        :no-data-text="'-'">
      <template v-slot:[`item.user`]="{ item }">
        {{ item.worker | user }}
      </template>

      <template v-slot:[`item.workDate`]="{ item }">
        <date-picker v-model="item.workDate"
                     dense
                     clearable/>
      </template>

      <template v-slot:[`item.workDuration`]="{ item }">
        <div class="d-flex flex-row align-baseline">
          <duration-select v-model="item.workDuration"
                           class="mr-2 mt-1 mb-1"
                           style="max-width: 8em;"
                           dense/>
          <v-btn @click="removeUser(item.worker)"
                 icon :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:footer>
        <div class="v-data-footer justify-start">
          <user-select-field :show-select-dialog-button="true"
                             :show-add-dialog-button="true"
                             :dense="true"
                             @change="addUser"
                             v-model="userToAdd"
                             class="mb-1 mt-1"
                             :label="$t('actions.add')"
                             :rules="[() => doneByUsers.length > 0 || $t('validation.required'), ]"/>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DurationSelect from '@/components/inputs/DurationSelect';
import UserSelectField from '@/components/inputs/UserSelectField';
import DatePicker from '@/components/inputs/DatePicker';

export default {
  name: 'DoneByUsersSelect',
  components: {
    DatePicker, UserSelectField, DurationSelect,
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data: () => ({
    userToAdd: null,
  }),
  methods: {
    addUser(user) {
      if (!user) {
        return;
      }

      if (this.doneByUsers.some((doneByUser => doneByUser.worker.id === user.id))) {
        this.userToAdd = null;
        return;
      }

      let doneByUser = {
        worker: user,
        workDuration: null,
        workDate: null,
      };
      this.doneByUsers.push(doneByUser);
      this.userToAdd = null;
    },
    removeUser(user) {
      this.doneByUsers = this.doneByUsers.filter((doneByUser => doneByUser.worker.id !== user.id));

    },
  },

  computed: {
    doneByUsers: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },


    headers() {
      return [
        {
          text: this.$t('service.doneByUser'),
          align: 'start',
          sortable: false,
          value: 'user',
        },
        {
          text: this.$t('service.userWorkDate'),
          align: 'start',
          sortable: false,
          value: 'workDate',
        },
        {
          text: this.$t('service.userWorkDuration'),
          align: 'start',
          sortable: false,
          value: 'workDuration',
          width: '16em',
        },

      ];
    },
  },
};
</script>

<style>

</style>
